export const characteristics = {
  N: {
    title: "characteristics.c_1.title", //"The Whisky Drinker", //"Consumer (Drinker)",
    low: "characteristics.c_1.low",
    med: "characteristics.c_1.med",
    high: "characteristics.c_1.high",
    icon: "drinker",
  },
  NE: {
    title: "characteristics.c_2.title", //"The Connoisseur", //"Whisky Expert",
    low: "characteristics.c_2.low",
    med: "characteristics.c_2.med",
    high: "characteristics.c_2.high",
    icon: "expert",
  },
  E: {
    title: "characteristics.c_3.title", //"The Influencer",
    low: "characteristics.c_3.low",
    med: "characteristics.c_3.med",
    high: "characteristics.c_3.high",
    icon: "influencer",
  },
  SE: {
    title: "characteristics.c_4.title", //"The Trend Setter", //"Status Expert",
    low: "characteristics.c_4.low",
    med: "characteristics.c_4.med",
    high: "characteristics.c_4.high",
    icon: "status",
  },
  S: {
    title: "characteristics.c_5.title", //"The Collector",
    low: "characteristics.c_5.low",
    med: "characteristics.c_5.med",
    high: "characteristics.c_5.high",
    icon: "collector",
  },
  SW: {
    title: "characteristics.c_6.title", //"The Contented", // "Decided & Settled",
    low: "characteristics.c_6.low",
    med: "characteristics.c_6.med",
    high: "characteristics.c_6.high",
    icon: "decided",
  },
  W: {
    title: "characteristics.c_7.title", //"The Experience Seeker", //"Seeker",
    low: "characteristics.c_7.low",
    med: "characteristics.c_7.med",
    high: "characteristics.c_7.high",
    icon: "seeker",
  },
  NW: {
    title: "characteristics.c_8.title", //"The Macallan Lover", //"Traditionalist",
    low: "characteristics.c_8.low",
    med: "characteristics.c_8.med",
    high: "characteristics.c_8.high",
    icon: "traditional",
  },
};

const macallanPage = encodeURIComponent(
  "https://www.themacallan.com/en/mtc?img=IMG_URL"
);

export const shareWaysList = [
  {
    icon: "download",
    name: "Save Image",
    tooltip: "journey.share_download_tooltip",
  },
  /*
  {
    icon: "mail",
    name: "Email",
    url: `mailto:?subject=${hardcodedShareTitle}&body=${hardcodedShareMessage} IMG_URL ${encodedHomePage}`,
    tooltip: "Share link to The Macallan Journey via email",
  },
  */
  {
    icon: "twitter",
    name: "Twitter",
    url: `https://twitter.com/intent/tweet?url=${macallanPage}&text=SHARE_TEXT`,
    tooltip: "journey.share_twitter_tooltip",
  },
  {
    icon: "facebook",
    name: "Facebook",
    url: `https://www.facebook.com/sharer.php?u=${macallanPage}&quote=SHARE_TEXT`,
    tooltip: "journey.share_facebook_tooltip",
  },
  {
    icon: "linkedin",
    name: "LinkedIn",
    url: `https://www.linkedin.com/shareArticle?mini=true&url=${macallanPage}&text=SHARE_TEXT`,
    tooltip: "journey.share_linkedin_tooltip",
  },
];
